/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
    MatchToJSONTyped,
} from './Match';

/**
 * 
 * @export
 * @interface GetLeagueMatchResponse
 */
export interface GetLeagueMatchResponse {
    /**
     * 
     * @type {Match}
     * @memberof GetLeagueMatchResponse
     */
    match: Match;
}

/**
 * Check if a given object implements the GetLeagueMatchResponse interface.
 */
export function instanceOfGetLeagueMatchResponse(value: object): value is GetLeagueMatchResponse {
    if (!('match' in value) || value['match'] === undefined) return false;
    return true;
}

export function GetLeagueMatchResponseFromJSON(json: any): GetLeagueMatchResponse {
    return GetLeagueMatchResponseFromJSONTyped(json, false);
}

export function GetLeagueMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'match': MatchFromJSON(json['match']),
    };
}

export function GetLeagueMatchResponseToJSON(json: any): GetLeagueMatchResponse {
    return GetLeagueMatchResponseToJSONTyped(json, false);
}

export function GetLeagueMatchResponseToJSONTyped(value?: GetLeagueMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'match': MatchToJSON(value['match']),
    };
}

